import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import Filters from '../components/Filters';
import MyDatePicker from '../../Accompaniment/components/MyDatePicker';
import { LinearProgress } from '@mui/material';

function FilterGroup({
    data
}) {
    const disabledButton = !data.employeeSelected && !data.selectedDepartment;

    return (
        <>
            <Typography sx={styles.Title}>
                Selecione os colaboradores para visualizar seus registros.
            </Typography>
            <Grid sx={styles.Grid}>
                <Grid style={{
                    display: 'flex',
                    width: '100%',
                    paddingTop: '15px',
                    marginRight: data.buttonBack == 1 ? '40px' : 0
                }}>
                    <Grid sx={data.buttonBack == 1 ? styles.GridFilterslargura : styles.GridFilters}>
                        <Filters
                            Title={'Departamento'}
                            data={data.department}
                            handleChangeFilter={data.handleChangeFilter}
                            selectedDepartment={data.selectedDepartment}
                        />
                    </Grid>
                    <Grid sx={data.buttonBack == 1 ? styles.GridFilterslargura : styles.GridFilters}>
                        <Filters
                            Title={'Colaborador'}
                            page={data.page}
                            data={data.employeeData}
                            employeeDataFilter={data.employeeDataFilter}
                            filterEmployee={data.filterEmployee}
                            employeeSelected={data.employeeSelected}
                            selectedEmployee={data.selectedEmployee}
                            viewEmployees={data.viewEmployees}
                        />
                    </Grid>
                    <Grid sx={data.buttonBack == 1 ? styles.GridFilterslargura : styles.GridFilters}>
                        <MyDatePicker
                            type={'Início'}
                            handleChangePeriod={data.handleChangePeriod}
                            endDate={data.endDate}
                            startDate={data.startDate}
                        />
                    </Grid>
                    <Grid sx={data.buttonBack == 1 ? styles.GridFilterslargura : styles.GridFilters}>
                        <MyDatePicker
                            type={'Fim'}
                            handleChangePeriod={data.handleChangePeriod}
                            endDate={data.endDate}
                            startDate={data.startDate}
                        />
                    </Grid>


                    <Grid sx={styles.GridButton}>
                        {/* <Button sx={styles.Button} onClick={() => setPage(1)} disabled={disabledButton}> */}
                        <Button sx={styles.Button} onClick={() => data.setPage(1)} >
                            <Typography sx={styles.TextButton}>
                                Buscar
                            </Typography>
                        </Button>
                    </Grid>

                </Grid>
            </Grid>
            {
                data.autoFix ?
                    <LinearProgress style={{ paddingTop: '10px' }} /> : null
            }
        </>
    )
}

export default FilterGroup;

const styles = ({
    Grid: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10px'
    },
    Title: {
        textAlign: 'start',
        paddingLeft: '0px',
        fontFamily: 'Montserrat',
        fontWeight: '600'
    },
    GridButtonBack: {
        width: '90px',
        paddingRight: '10px',
        marginRight: '55px',
        margin: '0px 55px 0px 25px'
    },
    ButtonBack: {
        backgroundColor: '#464953',
        padding: '10px',
        height: '55px',
        borderRadius: '15px',
        color: 'white',
        width: '100%',
        fontFamily: 'Montserrat',
    },
    TextButtonBack: {
        width: '100%',
        textAlign: 'center',
        fontFamily: 'Montserrat',
        textTransform: 'none'
    },
    GridFields: {
        display: 'flex',
        width: '100%',
        paddingTop: '15px'
    },
    GridFilters: {
        width: '50%',
        paddingRight: '7px'
    },
    GridFilterslargura: {
        width: '20%',
        paddingRight: '5px'
    },
    GridButton: {
        width: '95px',
        paddingRight: '10px'
    },
    Button: {
        backgroundColor: '#537ccd',
        padding: '10px',
        height: '55px',
        borderRadius: '15px',
        color: 'white',
        width: '100%',
        fontFamily: 'Montserrat',
    },
    TextButton: {
        width: '100%',
        textAlign: 'center',
        fontFamily: 'Montserrat',
        textTransform: 'none'
    }
})